import {
  Carousel,
  Items,
  WelcomeSection,
  OthersArea,
  BurgerSlider,
  VideoSection,
  ChooseOrder,
  FoodGallery,
  Delivery,
} from "../../Components";

const Home = () => {
  return (
    <>
      <Carousel />
      <Items />
      <WelcomeSection />
      <OthersArea />
      <BurgerSlider />
      <VideoSection />
      <ChooseOrder />
      <FoodGallery />
      <Delivery />
    </>
  );
};

export default Home;
